import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import GTranslateRoundedIcon from '@mui/icons-material/GTranslateRounded';

import icon from '../../assets/bg-ten-new.svg';
import ArrowForwardIosRounded from '../../assets/ArrowForwardIosRounded.svg';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;

  background-image: url(${icon});
  background-size: cover;

  .borderLock {
    width: 3vw;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  .title {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000000;
  }

  .btn-translate {
    position: absolute;
    right: 0;
    border-color: ${({ theme }) => theme.palette.grey[100]};
    color: ${({ theme }) => theme.palette.grey[100]};
    height: 2.4vw;
    width: 5.18vw;
    font-size: 1.02vw;
    font-weight: 400;
    gap: 9px;
  }

  .header {
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    margin-bottom: 20px;
  }

  .form-login {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }

  .submit-btn {
    width: 100%;
    height: 54px;
    display: flex;
    justify-content: center;
    font-size: 1rem;
  }

  .email {
    width: 100%;
  }

  .password {
    width: 100%;
  }

  .check {
    position: relative;
  }

  .section-logar {
    width: 29vw;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    align-content: center;
    background-color: transparent;
  }

  .line {
    width: 27.34vw;
    background: #e0e0e0;
  }

  .titleLine {
    color: #aaaaaa;
    font-size: 0.85vw;
    margin-left: 10px;
    margin-right: 10px;
  }

  .register-texto {
    color: var(--black, #000);
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    text-decoration-line: underline;
    text-transform: initial;
  }
`;
export const Header = styled(Box)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 576px;
  margin-bottom: 50px;

  img {
    width: 211.418px;
    height: 87.251px;
  }

  @media (max-width: 540px) {
    width: 100%;
    flex-direction: column;
    gap: 20px;
    margin-bottom: 30px;
    img {
      width: 160px;
      height: 67.251px;
    }
  }
`;

export const Divider = styled(Box)`
  height: 87.42px;
  width: 1px;
  background-color: #fff;
  @media (max-width: 540px) {
    width: 170.42px;
    height: 1px;
    background-color: #fff;
  }
`;
export const Div = styled(Box)`
  .recover-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 63%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ten-meetings {
    width: 180px;
    min-width: 180px;

    position: fixed;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    position: relative;
    top: 0.5rem;
    margin-top: 0.18rem;
    margin-bottom: 1.2rem;
    color: ${({ theme }) => theme.palette.grey[100]};
  }

  .title-company {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 34px;
    line-height: 42px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.25px;
    color: #000;
  }

  .container-input {
    width: 22rem;
  }

  .inputNumber {
    width: 2rem;
    height: 3rem;
    display: flex;
    position: relative;
    text-align: center;
    bottom: 0.4rem;
  }

  .container-confirm {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .btn-confirm {
    left: 0;
    right: 0;
    margin-bottom: 1.25rem;
    width: 6.25rem;
    height: 2.62rem;
  }

  .alert-validation {
    width: 411.8px;
    display: flex;
    justify-content: center;
    margin-top: 1.56rem;
  }
  .contentHeader {
    display: flex;
    justify-content: center;
    align-items: center;

    flex-direction: column;
    gap: 1.87rem;
  }

  .dialog-span {
    text-align: center;
    font-size: 0.93rem;
  }
  .modalTitle {
    font-size: 1.31rem;
    margin-top: 1rem;
  }

  .modal-email {
    margin-top: 3.2rem;
    width: 31.25rem;
  }

  .modal-confirm {
    margin-bottom: 4rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .icon-success {
    margin-top: 3.87rem;
  }

  .message-success {
    margin-top: 2rem;
  }

  h3 {
    font-size: 2.32rem;
  }
`;

export const CardContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding: 2px;
`;

export const TitleGov = styled(Typography)`
  color: #fff;
  font-family: Montserrat;
  font-size: 29px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  width: 222px;

  @media (max-width: 540px) {
    width: 133px;
    font-size: 17px;
    text-align: center;
  }
`;

export const Card = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 10px;
  width: 100%;
  height: 70px !important;
  background: #ffffff;
  border: 1px solid #dddddd;
  border-radius: 6px;
  cursor: pointer;
  justify-content: space-between;

  :hover {
    filter: brightness(0.97);
    ::after {
      content: url(${ArrowForwardIosRounded});
    }
  }
`;

export const CardTitle = styled(Box)`
  color: var(--black, #000);
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: 0.15px;
`;

export const Line = styled(Box)`
  border: 0.5px solid #b0b0b0;
  width: 100%;
  margin-top: 20px;
`;

export const LockIcon = styled(LockRoundedIcon)`
  width: 2vw;
  height: 2vw;
  color: ${({ theme }) => theme.palette.grey[100]};
`;

export const Icontranslate = styled(GTranslateRoundedIcon)`
  width: 1.22vw;

  color: ${({ theme }) => theme.palette.grey[100]};
`;

export const ContainerSocialLogin = styled(Box)`
  margin-top: 30px;
  width: 29vw;
  display: flex;
  flex-direction: column;
  gap: 1.56rem;
  justify-content: center;
  Button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 15px;
    height: 56px;
    border: 1px solid #323232;
    border-radius: 4px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #323232;
  }

  img {
    width: 1.43rem;
  }
`;

export const DivHeader = styled(Box)`
  align-items: center;
  width: 540px;
  display: flex;
  height: 4.62rem;
  justify-content: center;
  position: relative;
  top: -16px;

  .header {
    position: fixed;
  }

  .logo {
    position: fixed;
  }
`;
